import { createFileRoute } from "@tanstack/react-router";

import ObligationCataloguePage from "@/features/dashboard/pages/obligation-catalogue";

export const Route = createFileRoute("/(app)/ops/delivery/catalogue")({
  component: () => <ObligationCataloguePage />,
});
